<mat-card>
  <mat-card-content>
    <div>
      <div class="flex-row">
        <span class="typo-title">{{ title }}</span>
      </div>

      <ul>
        <li *ngFor="let license of licensee" class="prices">
          <span class="status">
            <mat-slide-toggle [checked]="license.status === LicenseeStatus.ENABLED"
                              [disabled]="true"
                              color="accent">
            </mat-slide-toggle>
          </span>
          <span class="amount">
            <span
              *ngIf="license.cost">{{ license.cost / UNIT_SIZE| number : '1.2-2' }} {{ license.currencyCode }}</span>
            <span class="faded" *ngIf="!license.cost">no Price</span>
          </span>
          <span class="buyer">{{ license.clientCustomerName || '[ ' + (license.clientId || 'GLOBAL') + ' ]' }}</span>
          <span class="actions" *ngIf="editable || removable">
            <button mat-icon-button (click)="editPrice(license)" *ngIf="editable">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button (click)="removePrice(license)" *ngIf="removable">
              <mat-icon>delete</mat-icon>
            </button>
          </span>
        </li>
      </ul>
    </div>
  </mat-card-content>
</mat-card>
